export interface IMatchOffer {
    id: number,

    offerDateTime: string,
    deadlineDateTime: string,
    decisionDateTime: string,

    recipientId: number,
    recipientAlias: string,
    recipientCpra4: number,
    recipientCenterId: number,
    recipientCenter: string,

    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenter: string,

    wasAcceptedNoIssues: boolean,
    wasDeclinedUnacceptable: boolean,
    wasAcceptedNotConfident: boolean,
    wasAcceptedNoIssuesAbove99Cpra: boolean,
    wasDeclinedUnacceptableAbove99Cpra: boolean,
    wasAcceptedNotConfidentAbove99Cpra: boolean,
    wasDeclinedSurgeonUnavailable: boolean,

    wasDeclinedOther: boolean,

    deadlineMissed: boolean,
}